import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledTagContainer: any = styled.div`
  display: flex;
  padding-bottom: 28px;
  width: 100%;
`;

export const StyledOfferTypeLabel: any = styled.div`
  background-color: #FFD100;
  color: black;
  display: inline-block;
  padding: 0px 10px 2px 10px;
`;

export const StyledDetailsContent: any = styled.div`
  padding-right: 15px;

  @media (min-width: ${Breakpoints.b1280}px) {
    padding: 0 20px 0 17px;
  }
`;

export const StyledSeparatorLine: any = styled.div`
  width: 100%;
  height: 1px;
  margin: 12px 0;
  background-color: #dfe4e8;

  @media (min-width: ${Breakpoints.b960}px) {
    margin: 17px 0;
  }
`;

export const StyledPriceDetails: any = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  margin-bottom: 40px;
`;

export const StyledPriceDetailsLine: any = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  > div {
    line-height: 1.5;
  }
`;

export const StyleBuyingCTAs:  any = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const StyledButton: any = styled.div`
  display: block;
  margin: 0 auto;
  margin-left: 0;
  margin-top: 28px;
  max-height: 44px;
  width: 96%;

  button {
    width: 100%;

    &:focus {
      outline: none;
    }
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    width: 88%;
    margin-top: 40px;
    margin-left: 5px;
    margin-right: 5px;
  }

  @media (min-width: ${Breakpoints.b960}px) {

    margin-left: 5px;
    margin-right: 5px;

    button {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

`;
